var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"chats","title":"Chats","hide-footer":""}},[_c('div',{staticClass:"chats-container"},[_c('chat-search'),_c('chats-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }